const CONFIG = {
  "metadata": {
    "version": "2026.06.01",
    "name": "Street Vendor Perceptual Survey",
    "description": "Additional questions for Street Vendors when they are enrolled in the study."
  },
  "structure": [
    {
      "id": "factors_affecting_business",
      "type": "multiple_choice_answer",
      "include_other": true,
      "title": "Factors Affecting Business",
      "infoText": "Please select any and all factors that have affected your business during the last 7 days.",
      "options": [
        "Fewer customers than usual",
        "Customers bought less product than usual",
        "Could not afford to buy enough stock",
        "Stock spoiled when received",
        "Stock spoiled or went bad quickly",
        "Supply delays or market closures",
        "Health problems limited my ability to work",
        "Family or caregiving responsibilities affected work",
        "Power cuts (e.g., affecting refrigeration or lighting)",
        "Extreme heat affected my ability to work",
        "Other weather factors (e.g., rain, flooding) disrupted my business"
      ],
      "include_na": true,
      "translation": {
        "es": {
          "title": "Factores que afectaron su negocio",
          "infoText": "Seleccione todos los factores que han afectado su negocio durante los últimos 7 días.",
          "options": [
            "Menos clientes de lo habitual",
            "Los clientes compraron menos producto de lo habitual",
            "No pude comprar suficiente mercancía",
            "La mercancía llegó en mal estado",
            "La mercancía se echó a perder rápidamente",
            "Retrasos en el suministro o cierres del mercado",
            "Problemas de salud limitaron mi capacidad de trabajar",
            "Responsabilidades familiares o de cuidado afectaron el trabajo",
            "Cortes de energía (por ejemplo, afectando refrigeración o iluminación)",
            "El calor extremo afectó mi capacidad de trabajar",
            "Otros factores climáticos (por ejemplo, lluvia, inundaciones) afectaron mi negocio"
          ]
        },
        "gu": {
          "options": [
            "સામાન્ય કરતા ઓછા ગ્રાહકો આવ્યા",
            "સામાન્ય કરતા ગ્રાહકોએ ઓછો માલ ખરીદયો ",
            "પૂરતો સ્ટોક ખરીદવા પૈસા ન હતા",
            "સ્ટોક મળતાની સાથે બગડી ગયો",
            "સ્ટોક ઝડપથી ખરાબ થઈ ગયો",
            "સપ્લાયમાં મોડું થયું અથવા બજાર બંધ રહ્યું",
            "તબિયતની સમસ્યાને કારણે કામ કરી શક્યા નહીં",
            "પરિવારની જવાબદારીઓના કારણે કામ પર અસર પડી",
            "વીજળી જતી રહેવી (ફ્રિજ અથવા લાઈટ પર અસર થવી)",
            "બહુ ગરમીને કારણે કામ કરવું મુશ્કેલ બન્યું",
            "અન્ય હવામાન કારણો (વરસાદ, પૂર)થી ધંધામાં અડચણ આવી"
          ],
          "title": "ધંધા પર અસર કરનાર પરિબળો ",
          "infoText": "છેલ્લા ૭ દિવસમાં તમારા ધંધા પર જે જે બાબતોની અસર પડી હોય તે બધું પસંદ કરો."
        },
        "hi": {
          "options": [
            "आम दिनों से कम ग्राहक आए",
            "ग्राहकों ने आम दिनों से कम सामान खरीदा",
            "इतना पैसा नहीं था कि पूरा स्टॉक खरीद सकें",
            "स्टॉक मिलते ही खराब हो गया",
            "स्टॉक जल्दी खराब हो गया",
            "सामान आने में देरी हुई या बाजार बंद रहे",
            "सेहत की समस्या के कारण काम नहीं कर पाए",
            "परिवार की जिम्मेदारियों/देखभाल के कारण काम प्रभावित हुआ",
            "बिजली कटौती हुई (जैसे फ्रिज या लाइट पर असर पड़ा)",
            "ज्यादा गर्मी के कारण काम करना मुश्किल हुआ",
            "मौसम की दूसरी समस्याएं (जैसे बारिश, बाढ़) से व्यापार प्रभावित हुआ"
          ],
          "title": "व्यापार को प्रभावित करने वाले कारण",
          "infoText": "कृपया पिछले 7 दिनों में आपके व्यापार को प्रभावित करने वाले सभी कारण चुनें:"
        }
      }
    }
  ]
} 
export default CONFIG